import { useEffect, useState } from 'react';
import axios from 'axios';

const URL = `${process.env.REACT_APP_BACKEND_URL}/api/ai-studio/services`;
let cache = { at: 0, p: null };

/** Studio tool readiness (plain words), cached for a minute across cards. */
export function useStudioServices() {
  const [s, setS] = useState(null);
  useEffect(() => {
    if (!cache.p || Date.now() - cache.at > 60000) {
      cache = { at: Date.now(), p: axios.get(URL, { withCredentials: true }).then((r) => r.data.services)
        .catch(() => { cache = { at: 0, p: null }; return {}; }) };  // a failed check is retried next time; the server still pre-flights
    }
    cache.p.then(setS);
  }, []);
  return s;
}

/** First service of `ids` that isn't ready, or null. While the check is loading, paid buttons stay disabled (fail closed). */
export const notReady = (services, ids) => (!ids.length ? null : !services ? { loading: true }
  : ids.map((i) => services[i]).find((x) => x && x.state !== 'ready') || null);

export function ServiceNote({ svc, testId }) {
  if (!svc || svc.loading) return null;
  return (
    <div className="mb-3 rounded-md border border-amber-400/30 bg-amber-500/10 px-3 py-2 text-[11px] text-amber-100" data-testid={testId}>
      {svc.label} isn't available on this server right now — {svc.reason ? svc.reason.charAt(0).toLowerCase() + svc.reason.slice(1) : 'it is down'}. Nothing will be charged.
    </div>
  );
}
